import useSWR from 'swr';
import axios from 'axios';

function usePotentialHireCategories() {
  return useSWR(`${process.env.REACT_APP_API_URL}/potential-hires/categories`, async (url) => {
    const { data: { categories } } = await axios.get(url);
    return categories;
  });
}

export default usePotentialHireCategories;
